<template>
  <div class="eventsDetails">
    <div class="title">
      <span>当前位置：&nbsp;</span>
      <span>资讯中心</span>
      <span>></span>
      <span @click="backEvents">行业资讯</span>
      <span>></span>
      <span>资讯详情</span>
    </div>
    <div class="content">
      <div class="content_top">
        <p class="content_top_title">{{ title }}</p>
        <p class="content_top_content">
          <span>{{ uploadDate ? uploadDate : createDate }}</span>
          <span>
            围观
            <b>{{ watchs }}</b
            >次
          </span>
        </p>
      </div>
      <div class="content_center" v-html="content"></div>
      <div class="content_bottom">
        <div class="pre_next">
          <div class="pre">
            <p></p>
            <p>上一条新闻</p>
            <p @click="preNew">
              {{ newPreTitle ? newPreTitle.title : "" }}
              <span style="margin-left: 9px">>></span>
            </p>
          </div>
          <div class="next">
            <p></p>
            <p>下一条新闻</p>
            <p @click="nextNew">
              {{ newNextTitle ? newNextTitle.title : "" }}
              <span style="margin-left: 9px">>></span>
            </p>
          </div>
        </div>

        <p class="zanTopLine"></p>
        <div class="zan">
          <div class="zan_left">
            <img src="../../assets/image/weixin.png" alt />
            <!-- <img src="../../assets/image/weibo.png" alt @click="shareWB" /> -->
            <img src="../../assets/image/weibo.png" alt />
          </div>
          <div
            class="zan_center"
            :class="{ fabulousBack: fabulous_click }"
            @click="fabulousClick"
          >
            <img src="../../assets/image/zan.png" alt />
            <p class="num">{{ fabulous }}</p>
            <p>赞</p>
          </div>
          <div class="zan_right">
            <!-- 收藏
            <p></p> -->
          </div>
        </div>

        <div class="tj">
          <div class="line_industry">
            <span>相关新闻</span>
            <span class="line"></span>
          </div>
          <ul>
            <li>
              <p>
                教育装备企业云访谈&nbsp;|&nbsp;迪声音响&nbsp;&nbsp;顺势而为&nbsp;&nbsp;强力抗“疫”
              </p>
            </li>
            <li>
              <p>
                教育装备企业云访谈&nbsp;|&nbsp;迪声音响&nbsp;&nbsp;顺势而为&nbsp;&nbsp;强力抗“疫”
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: "",
      watchs: 0,
      createDate: "",
      uploadDate: "",
      content: "",
      preTitle: null,
      nextTitle: null,
      fabulous_click: null,
      fabulous: null,
      eventsDataList: [],
      routeQuery: null,
    };
  },
  computed: {
    newNextTitle() {
      return this.nextTitle;
    },
    newPreTitle() {
      return this.preTitle;
    },
  },
  watch: {},
  created() {},
  mounted() {
    this.routeQuery = this.$route.query;
    if (this.routeQuery) {
      this.getEventInformationDetail(this.routeQuery.code * 1);
    }
    let tokenStatus = this.$cookie.get("gzToken");
    if (tokenStatus) {
      let data = this.tokenRules(tokenStatus, 0, this.routeQuery.code * 1, "3");
      if (data) {
        data.then((response) => {
          if (response.fabulousCollection === true) {
            this.fabulous_click = true;
          }
        });
      }
    }
  },
  methods: {
    getInformationList() {
      return this.$http({
        url: "information/getInformationByTypeList",
        method: "post",
        params: {
          type: "0",
        },
      }).then((response) => {
        let { code, zhInformationList } = response.data;
        // this.eventsDataList = zhInformationList;
        if (code === 0) {
          return zhInformationList;
        }
      });
    },

    // 当前资讯信息
    getEventInformationDetail(currentId) {
      this.$http({
        url: "information/getInformationById",
        method: "post",
        params: {
          id: currentId,
        },
      }).then(({ data }) => {
        let { code, information } = data;
        if (code === 0) {
          this.title = information.title;
          this.content = information.content.replace(
            /<img/g,
            "<img style='max-width: 100%;height: auto; crossOrigin; display: block; margin: 0 auto;' "
          );
          this.watchs = information.watchs;
          this.createDate = information.createDate.substring(0, 10);
          this.uploadDate = information.uploadDate
            ? information.uploadDate.substring(0, 10)
            : "";
          this.fabulous = information.fabulous <= 0 ? 0 : information.fabulous;
          this.preInformation(currentId);
        }
      });
    },

    // 微博分享
    shareWB() {
      event.preventDefault();
      var _shareUrl = "http://v.t.sina.com.cn/share/share.php?"; //真实的appkey，必选参数
      _shareUrl += "&url=" + encodeURIComponent("" || document.location); //参数url设置分享的内容链接|默认当前页location，可选参数
      _shareUrl += "&title=" + encodeURIComponent(this.title); //参数title设置分享的标题|默认当前页标题，可选参数
      _shareUrl += "&source=" + encodeURIComponent("");
      _shareUrl += "&sourceUrl=" + encodeURIComponent("");
      _shareUrl += "&content=" + "utf-8"; //参数content设置页面编码gb2312|utf-8，可选参数
      _shareUrl += "&pic=" + encodeURIComponent(""); //参数pic设置图片链接|默认为空，可选参数
      window.open(_shareUrl, "_blank");

      //  event.preventDefault();
      //   var _shareUrl = 'http://v.t.sina.com.cn/share/share.php?&appkey=895033136';     //真实的appkey，必选参数
      //   _shareUrl += '&url='+ encodeURIComponent(_url||document.location);     //参数url设置分享的内容链接|默认当前页location，可选参数
      //   _shareUrl += '&title=' + encodeURIComponent(_title||document.title);    //参数title设置分享的标题|默认当前页标题，可选参数
      //   _shareUrl += '&source=' + encodeURIComponent(_source||'');
      //   _shareUrl += '&sourceUrl=' + encodeURIComponent(_sourceUrl||'');
      //   _shareUrl += '&content=' + 'utf-8';   //参数content设置页面编码gb2312|utf-8，可选参数
      //   _shareUrl += '&pic=' + encodeURIComponent(_pic||'');  //参数pic设置图片链接|默认为空，可选参数
      //   window.open(_shareUrl,'_blank','width='+_width+',height='+_height+',top='+_top+',left='+_left+',toolbar=no,menubar=no,scrollbars=no, resizable=1,location=no,status=0');
    },

    // 点赞
    fabulousClick() {
      var gztk = this.$cookie.get("gzToken");
      if (gztk) {
        this.fabulousFunction();
      } else {
        this.$router.push({
          path: "/audLogin",
        });
      }
    },
    fabulousFunction() {
      this.$http({
        url: "viewer/ZhInformationFabulous",
        method: "post",
        params: {
          zhType: "3",
          zhId: this.routeQuery.code * 1,
        },
      }).then(({ data }) => {
        if (data.code === 0) {
          this.fabulous_click = !this.fabulous_click;
          this.fabulous = data.fabulous <= 0 ? 0 : data.fabulous;
        }
      });
    },

    // 当前资讯的index
    async preInformation(currentId) {
      let typeLits = await this.getInformationList();
      let eventInfoIndex = typeLits.findIndex((item) => item.id === currentId);
      let preInfoObj = typeLits[eventInfoIndex - 1]
        ? typeLits[eventInfoIndex - 1]
        : typeLits[typeLits.length - 1];
      this.preTitle = preInfoObj;
      let nextInfoObj = typeLits[eventInfoIndex + 1]
        ? typeLits[eventInfoIndex + 1]
        : typeLits[0];
      this.nextTitle = nextInfoObj;
    },

    // 上一条新闻
    preNew() {
      this.getEventInformationDetail(this.preTitle.id);
      this.preInformation(this.preTitle.id);
    },
    // 下一条新闻
    nextNew() {
      this.getEventInformationDetail(this.nextTitle.id);
      this.preInformation(this.nextTitle.id);
    },

    backEvents() {
      this.$router.push({
        path: "/information/eventsInfo",
      });
    },
  },
};
</script>>
<style lang="scss" scoped>
.eventsDetails {
  min-height: 1470px;
  background-color: #ffffff;
  box-shadow: -8px 0px 8px #fafafa, 0px -8px 8px #fafafa, 0px 8px 8px #fafafa;
  margin-bottom: 45px;
  padding-bottom: 1px;
  .title {
    height: 43px;
    border-bottom: 1px solid #e5e5e5;
    line-height: 43px;
    padding-left: 17px;
    color: #b6b6b6;
    font-size: 12px;
    span:nth-child(3),
    span:nth-child(5) {
      margin: 0 11px;
    }
    span:nth-child(4) {
      cursor: pointer;
    }
  }
  .content {
    width: 857px;
    min-height: 892px;
    margin: 50px auto 63px;
    .content_top {
      /* height: 110px; */
      border-bottom: 1px solid #dfe1e1;
      position: relative;
      .content_top_title {
        padding: 0 24px 30px 10px;
        line-height: 45px;
        font-size: 28px;
        text-align: center;
      }
      .content_top_content {
        width: 200px;
        text-align: right;
        font-size: 12px;
        color: #bbbbbb;
        position: absolute;
        right: 0;
        bottom: 5px;
        span:first-child {
          margin-right: 23px;
        }
        // margin-top: -23px;
      }
    }
    .content_center {
      min-height: 542px;
      padding: 20px 0;
    }
    .content_bottom {
      margin-top: 30px;
      .pre_next {
        height: 60px;
        margin-bottom: 56px;
        position: relative;
        .pre {
          float: left;
        }
        .next {
          float: right;
        }
        .pre,
        .next {
          width: 400px;
          height: 60px;
          background-color: #f2f2f2;
          font-size: 12px;
          p:first-child {
            position: absolute;
            width: 4px;
            height: 60px;
            background-color: #d71b1c;
          }
          p:nth-child(2) {
            color: #919191;
            margin: 8px 0 8px 21px;
          }
          p:last-child {
            width: 328px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            margin-left: 21px;
            color: #1879c0;
            border-bottom: 1px solid #1879c0;
            cursor: pointer;
          }
        }
      }
      .tj {
        height: 120px;
        border-bottom: 1px solid #dfe1e1;
        .line_industry {
          height: 20px;
          color: #333333;
          .line {
            display: block;
            float: right;
            width: 785px;
            height: 1px;
            background-color: #dfe1e1;
            margin-top: 11px;
          }
        }
        ul {
          li {
            width: 311px;
            cursor: pointer;
            list-style: square;
            font-size: 12px;
            margin-top: 20px;
            margin-left: 21px;
            border-bottom: 1px solid #1879c0;
            p {
              color: #1879c0;
            }
          }
        }
      }
    }
  }
}
</style>